module.exports = __webpack_public_path__ + "static/img/72010B_4_R_20200730_LC.66efd52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/72010B_4_R_20200730_LC.png
// module id = 08WV
// module chunks = 0